import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import LiteratureThumbHtmlView from './LiteratureHtml';
import LiteratureThumbReactView from './Literature';
const LiterartureThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(LiteratureThumbHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(LiteratureThumbReactView, _extends({}, props));
};
LiterartureThumbView.displayName = 'LiterartureThumbView';
export default LiterartureThumbView;
